let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("st495")).then(() => parcelRequire('fDHwb'));